import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Shield, MapPin, Clock } from 'lucide-react';

const Footer = () => {

  return (
    <footer id="contact" className="relative bg-gradient-to-br from-slate-900 via-emerald-900/30 to-slate-800 text-white border-t border-emerald-400/30">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 25% 25%, rgba(16, 185, 129, 0.15) 0%, transparent 60%), 
                           radial-gradient(circle at 75% 75%, rgba(16, 185, 129, 0.12) 0%, transparent 55%),
                           radial-gradient(circle at 50% 50%, rgba(6, 78, 59, 0.1) 0%, transparent 40%)`
        }}></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-6 py-8">
        <div className="max-w-md">
          {/* Contact Information */}
          <div className="space-y-2">
            <h3 className="text-xl font-bold text-white mb-4 drop-shadow-md" style={{
              textShadow: '0 0 15px rgba(255,255,255,0.2)'
            }}>Contact Us</h3>
            <div className="space-y-3">
              <a
                href="mailto:safeplayai.info@gmail.com"
                className="flex items-center text-gray-300 hover:text-emerald-300 transition-all duration-300 group p-3 rounded-xl hover:bg-emerald-400/10 border border-transparent hover:border-emerald-400/20 backdrop-blur-sm space-x-3"
              >
                <div className="w-8 h-8 bg-emerald-400/20 rounded-xl flex items-center justify-center group-hover:bg-emerald-400/30 transition-all duration-300 group-hover:scale-110 shadow-lg">
                  <Mail className="w-4 h-4 text-emerald-400 drop-shadow-sm" />
                </div>
                <div>
                  <p className="font-semibold text-sm text-white drop-shadow-sm">Email</p>
                  <p className="text-sm text-gray-400 group-hover:text-gray-300 transition-colors">safeplayai.info@gmail.com</p>
                </div>
              </a>
              <a
                href="tel:+19083073943"
                className="flex items-center text-gray-300 hover:text-emerald-300 transition-all duration-300 group p-3 rounded-xl hover:bg-emerald-400/10 border border-transparent hover:border-emerald-400/20 backdrop-blur-sm space-x-3"
              >
                <div className="w-8 h-8 bg-emerald-400/20 rounded-xl flex items-center justify-center group-hover:bg-emerald-400/30 transition-all duration-300 group-hover:scale-110 shadow-lg">
                  <Phone className="w-4 h-4 text-emerald-400 drop-shadow-sm" />
                </div>
                <div>
                  <p className="font-semibold text-sm text-white drop-shadow-sm">Phone</p>
                  <p className="text-sm text-gray-400 group-hover:text-gray-300 transition-colors">+1 (908) 307-3943</p>
                </div>
              </a>
            </div>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="mt-8 pt-6 border-t border-emerald-400/20">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
            <div className="flex items-center space-x-2 text-sm text-gray-400 drop-shadow-sm">
              <span>© 2025 SafePlay AI</span>
              <span>•</span>
              <span>All rights reserved</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;